export default {"src":"/_next/static/media/logo-red.27a28220.svg","height":24,"width":56,"blurWidth":0,"blurHeight":0};